export const PROTOPIE_ACCOUNT_ID_FIELDS = [
    'account_key',
    'cloud_url',
    'salesforce_account_id',
];
export const defineProtopieForm = (definition) => definition;
export const toClientFormDefinition = (form) => ({
    key: form.key,
    version: form.version,
    title: form.title,
    description: form.description,
    fields: form.fields,
    accountIdFields: form.accountIdFields,
});
//# sourceMappingURL=defineForm.js.map